import { render, staticRenderFns } from "./add-paper-from-local.html?vue&type=template&id=4f2627b5&scoped=true&"
import script from "./add-paper-from-local.js?vue&type=script&lang=js&"
export * from "./add-paper-from-local.js?vue&type=script&lang=js&"
import style0 from "./add-paper-from-local.scss?vue&type=style&index=0&id=4f2627b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2627b5",
  null
  
)

export default component.exports